// Below MIN_TERM_LENGTH, keep the server-rendered default suggestions (see design.md).

const MIN_TERM_LENGTH = 2;
const DEBOUNCE_MS = 300;

function renderSuggestion(product) {
	const link = document.createElement('a');
	link.className = 'c-search-overlay__suggestion';
	link.href = product.url;

	const thumb = document.createElement('img');
	thumb.className = 'c-search-overlay__suggestion-thumb';
	thumb.src = product.thumb || '';
	thumb.alt = '';
	link.appendChild(thumb);

	const info = document.createElement('span');
	info.className = 'c-search-overlay__suggestion-info';

	const name = document.createElement('span');
	name.className = 'c-search-overlay__suggestion-name';
	name.textContent = product.title;
	info.appendChild(name);

	const price = document.createElement('span');
	price.className = 'c-search-overlay__suggestion-price';
	price.textContent = product.price;
	info.appendChild(price);

	link.appendChild(info);

	return link;
}

function initSearchOverlay() {
	const overlay = document.getElementById('search-overlay');
	if (!overlay) {
		return;
	}

	const input = overlay.querySelector('#search-inp');
	const suggestions = overlay.querySelector('.c-search-overlay__suggestions');
	const loading = overlay.querySelector('#search-loading');
	if (!input || !suggestions) {
		return;
	}

	const defaultSuggestionsHTML = suggestions.innerHTML;
	let debounceTimer = null;

	function showDefault() {
		suggestions.innerHTML = defaultSuggestionsHTML;
	}

	function showResults(products) {
		suggestions.innerHTML = '';
		products.forEach((product) => {
			suggestions.appendChild(renderSuggestion(product));
		});
	}

	function search(term) {
		if (loading) {
			loading.classList.add('is-active');
		}

		const url = window.vbpData.ajaxUrl
			+ '?action=vbp_live_search'
			+ '&nonce=' + encodeURIComponent(window.vbpData.liveSearchNonce)
			+ '&term=' + encodeURIComponent(term);
		fetch(url).then((response) => response.json()).then((json) => {
			// Ignore stale responses — only render if the term sent still matches the current input value.
			if (json && json.success && input.value.trim() === term) {
				showResults(json.data);
			}
		}).finally(() => {
			if (loading) {
				loading.classList.remove('is-active');
			}
		});
	}

	input.addEventListener('input', () => {
		const term = input.value.trim();
		clearTimeout(debounceTimer);

		if (term.length < MIN_TERM_LENGTH) {
			showDefault();
			return;
		}

		debounceTimer = setTimeout(() => {
			search(term);
		}, DEBOUNCE_MS);
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initSearchOverlay();
});
